(() => {
  if (window.CiciniaMensProductLoaded) return;
  window.CiciniaMensProductLoaded = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-mens-linked-product]');
    if (!swatch || event.defaultPrevented) return;
    const url = swatch.getAttribute('href');
    if (!url || url === window.location.pathname) return;
    event.preventDefault();
    window.location.assign(url);
  });
})();
